module.exports = __webpack_public_path__ + "static/media/t-2-q-2.49491a23.jpg";